
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13179',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13179",
  "apollo-dlb": "static-3.97",
  "breeze-builder-lib": "static-1.698",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9931",
  "foundations-components": "static-1.8450",
  "foundations-components-legacy": "static-1.1475",
  "foundations-theming": "static-1.4747",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8305",
  "hub-http-shared-msw-handlers": "static-1.10573",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11760",
  "I18n": "static-7.1668",
  "jasmine-runner": "static-1.6726",
  "marketplace-discovery-studio-lib": "static-1.593",
  "marketplace-storefront-base": "static-1.13242",
  "quartz": "static-1.7422",
  "react-dlb": "static-1.88",
  "react-rhumb": "static-1.16991",
  "reactive-variable-buffer-atom": "static-1.3128",
  "reporting-testing-lib": "static-1.10663",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12796",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7593",
  "ui-addon-i18n": "static-1.11419",
  "ui-addon-react-router-dom": "static-1.9811",
  "unified-auth": "static-1.864",
  "unified-auth-core-lib": "static-1.1146",
  "usage-tracker": "static-1.7629",
  "usage-tracker-core": "static-1.7479",
  "customer-data-property-utils": "static-1.8375",
  "hub-http": "static-1.6486",
  "integrations-lib": "static-1.16982",
  "marketplace-ui-common": "static-1.20665",
  "marketplace-ui-install": "static-1.651",
  "property-management-iframe": "static-1.14081",
  "quartz-config": "static-1.1200",
  "quartz-core": "static-1.6641",
  "quartz-routing": "static-1.852",
  "quick-fetch": "static-1.4111",
  "react": "static-7.192",
  "rpc-client-utils": "static-1.4938",
  "ts-schema": "static-1.4274",
  "ui-universal-auth": "static-1.9350",
  "UIComponents": "static-3.8706",
  "apollo-stack-hubspot": "static-3.91",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3601",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3699",
  "quartz-webpack": "static-1.3646",
  "bend-plugin-quartz-routing": "static-1.500",
  "ai-components-ui-library": "static-1.9662",
  "codemirror": "static-5.99",
  "foundations-assets": "static-1.5156",
  "pulse": "static-1.902",
  "react-codemirror": "static-1.10913",
  "ui-extensions-preview-lib": "static-1.554",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4719",
  "floating-ui": "static-1.62",
  "foundations-theming-specialty": "static-1.2463",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9699",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.67",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5537",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.500",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2567",
  "ui-fonts": "static-1.1022",
  "ui-images": "static-2.1238",
  "bend-plugin-foundations-theming": "static-1.3230",
  "foundations-theming-base": "static-1.3732",
  "stylex": "static-1.38",
  "HeadJS": "static-2.793",
  "hs-test-utils-bend-plugin": "static-1.3416",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4587",
  "ui-addon-video-player": "static-1.8975",
  "ai-rendering-library": "static-1.11053",
  "chirp-fetch": "static-1.2167",
  "connections-embed-lib": "static-1.1475",
  "copilot-toolkit": "static-1.11805",
  "feedback-loader": "static-1.29773",
  "laboratory-lib": "static-3.7424",
  "marketplace-embed": "static-1.22857",
  "marketplace-ui-details": "static-1.10560",
  "marketplace-ui-reviews": "static-1.20620",
  "marketplace-ui-tracking": "static-1.14835",
  "sanitize-text": "static-1.8427",
  "usage-tracker-multi": "static-1.6043",
  "usage-tracker-session-replay": "static-1.5315",
  "wootric-nps": "static-1.7180",
  "quartz-head": "static-1.1087",
  "web-vitals": "static-1.12",
  "apollo-link-hub-http": "static-2.4929",
  "immer": "static-1.94",
  "immerable": "static-1.4423",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2665",
  "reporting-data": "static-1.68730",
  "cssUtils": "static-1.893",
  "flux-actions": "static-1.365",
  "react-colorpicker": "static-2.10481",
  "react-dnd-compat": "static-1.4890",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10642",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7619",
  "icons": "static-2.677",
  "marketplace-ui-apps-core": "static-1.19197",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4782",
  "foundations-components-test-utils": "static-1.5933",
  "quartz-i18n": "static-1.1097",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.411",
  "ads-unified-auth-lib": "static-1.1216",
  "google-sheets-integration-lib": "static-1.982",
  "microsoft-drive-auth-lib": "static-1.77",
  "surveymonkey-integration-lib": "static-1.422",
  "slack-ui-library": "static-1.10671",
  "fsm": "static-1.4021",
  "customer-data-objects": "static-1.7963",
  "property-translator": "static-1.5671",
  "hs-locale-management": "static-1.274",
  "frontend-preferences-client": "static-1.8196",
  "hs-promise-utils": "static-1.5870",
  "hubspot-apollo-client": "static-1.5152",
  "integrations-error-boundary-lib": "static-1.14397",
  "integrations-tracking-lib": "static-1.5881",
  "native-integrations-shared-strings": "static-1.8052",
  "sanitize": "static-1.4747",
  "superstore": "static-1.5030",
  "ui-shepherd-react": "static-3.10540",
  "ai-settings-ui-library": "static-1.8288",
  "hub-http-janus": "static-1.874",
  "hubspotter-http": "static-1.4845",
  "immutable-less": "static-1.4923",
  "marketplace-ui-client-types": "static-1.18072",
  "nav-meta": "static-1.30408",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18347",
  "ui-product-approvals-common": "static-1.965",
  "ai-studio-lib": "static-1.12411",
  "hubspot-prosemirror": "static-1.18923",
  "integrations-reconnect-lib": "static-1.448",
  "ui-addon-iframeable": "static-1.9350",
  "ui-addon-integrations-directory-panel": "static-2.8298",
  "ui-product-approvals": "static-1.29070",
  "ui-tool-access": "static-1.10426",
  "inbound-db-properties-service-client": "static-1.4037",
  "property-management-common": "static-1.6369",
  "opentelemetry-fe-types": "static-1.43",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.574",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.418",
  "quartz-auth": "static-1.1097",
  "quartz-test": "static-1.1097",
  "quartz-tracking": "static-1.801",
  "trellis-components": "static-1.2586",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.348",
  "HubStyle": "static-2.12067",
  "bender-build-tools": "static-1.3425",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22843",
  "ContentUtils": "static-1.69077",
  "customer-data-objects-ui-components": "static-1.13304",
  "sassPrefix": "static-1.166",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.405",
  "batch-promise": "static-1.1817",
  "event-emitter": "static-1.1226",
  "fast-json-patch": "static-1.67",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5737",
  "magpie-types": "static-1.5197",
  "stylex-utils": "static-1.137",
  "trellis-theming": "static-1.1243",
  "avatar-components": "static-1.2766",
  "breeze-engine-core": "static-1.929",
  "breeze-onboarding-components": "static-1.667",
  "customer-data-filters-ui": "static-1.40836",
  "customer-data-reference-ui-components": "static-1.13452",
  "embedded-academy-lib": "static-1.15459",
  "ExportDialog": "static-6.10652",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41973",
  "reporting-snowflake": "static-1.57347",
  "reporting-ui-components": "static-2.66000",
  "reporting-visualizations": "static-1.60805",
  "trial-components-library": "static-1.14067",
  "ui-addon-teams": "static-1.21880",
  "upgrade-components-lib": "static-1.482",
  "navigation-components": "static-1.18771",
  "breeze-engine-lib": "static-1.1651",
  "simple-logging-lib": "static-1.3324",
  "fail-safe": "static-1.226",
  "app-governance-lib": "static-1.2345",
  "developer-experience-shared-components": "static-1.10777",
  "purchase-motions-components": "static-1.6316",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10154",
  "usage-tracker-anonymous": "static-1.6046",
  "usage-tracker-public": "static-1.7440",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3974",
  "reference-resolvers": "static-1.8455",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4191",
  "hubspot-apollo-cache": "static-1.611",
  "universal-page-editor-lib": "static-1.3281",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3488",
  "atom": "static-1.5358",
  "merchandise-lib": "static-1.276",
  "salesImages": "static-1.537",
  "ui-addon-draggable": "static-3.5031",
  "content-assistance-lib": "static-1.8165",
  "content-media-capture": "static-1.5380",
  "customer-data-ui-utilities": "static-1.10102",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24430",
  "growth-payments-core": "static-1.26129",
  "knowledge-content-types": "static-1.8638",
  "PatternValidationJS": "static-1.3168",
  "payment-link-components": "static-1.24120",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20271",
  "ui-addon-emoji-picker": "static-1.10159",
  "ui-business-units-lib": "static-1.9360",
  "video-components-external": "static-1.12108",
  "video-data-lib": "static-1.35766",
  "navigation-messaging": "static-1.8098",
  "collaboration-sidebar": "static-1.58665",
  "crm-component-utils": "static-1.39785",
  "crm-properties-common-lib": "static-1.6163",
  "customer-data-properties": "static-1.52504",
  "external-options-client-types": "static-1.4320",
  "framework-data-schema-resolvers": "static-1.7165",
  "property-value-citations": "static-1.3118",
  "reference-resolvers-lite": "static-1.8376",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10571",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5088",
  "content-icons-ui": "static-1.2336",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.993",
  "breeze-artifacts-sdk": "static-1.256",
  "onboarding-journeys-lib": "static-1.868",
  "conversations-skeleton-state": "static-1.7519",
  "crm-message-bus": "static-1.43703",
  "customer-data-filters-ui-msw-helpers": "static-1.23271",
  "events-data-lib": "static-1.516",
  "FormUrlGenerator": "static-2.5000",
  "framework-builder-read-service-client": "static-1.4202",
  "hs-resources": "static-1.466",
  "multi-account-reference-resolvers": "static-1.1273",
  "onboarding-scopes": "static-1.6726",
  "onboarding-tours": "static-1.17080",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14418",
  "academy-common-lib": "static-1.14919",
  "dashboard-lib": "static-1.82736",
  "getting-started-shared-tasks": "static-1.19186",
  "hubspot-prosemirror-plugins": "static-1.18915",
  "share-with-third-party-component-lib": "static-1.8977",
  "ui-asset-management-lib": "static-1.11371",
  "user-context": "static-1.5392",
  "reporting-plugins": "static-1.10711",
  "reporting-reports": "static-1.68407",
  "hubs-service-types": "static-1.1531",
  "purchase-motions-api": "static-1.6319",
  "signup-constants": "static-1.19568",
  "nest": "static-1.509",
  "breeze-engine-chat-components": "static-1.629",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.177",
  "framework-listing-lib": "static-2.29441",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31375",
  "apps-service-types": "static-1.4013",
  "oauth-service-types": "static-1.4510",
  "signup-ui-url-generator": "static-2.8335",
  "onboarding-tours-client": "static-1.5294",
  "one-click-checkout": "static-1.343",
  "platform-infra-nav-components": "static-1.7874",
  "subscription-experience-data-types": "static-1.15224",
  "crm-record-cards-service-types": "static-1.3767",
  "location-customization-utils-lib": "static-1.10048",
  "redux-thunk": "static-2.77",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29260",
  "content-media-composition-data-lib": "static-1.13184",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4698",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.669",
  "ui-addon-opt": "static-4.8637",
  "commerce-tours-lib": "static-1.6577",
  "growth-onboarding-reliability": "static-1.5353",
  "sales-checkout-service-client": "static-1.3803",
  "data-token-picker": "static-1.16852",
  "FileManagerLib": "static-1.40070",
  "content-media-compositions": "static-2.17191",
  "media-bridge-lib": "static-1.19372",
  "chatspot-widget-iframe": "static-1.22834",
  "collaboration-sidebar-common": "static-1.3462",
  "marketing-platform-lib": "static-1.7142",
  "card-properties-lib": "static-1.44959",
  "commerce-subscription-lib": "static-1.37727",
  "crm-actions": "static-1.6625",
  "crm-cards-sdk": "static-1.44493",
  "customer-data-properties-shared-msw-handlers": "static-1.9900",
  "customer-data-tracking": "static-1.7154",
  "calling-global-api": "static-1.65506",
  "calling-internal-common": "static-1.31591",
  "calling-lifecycle-internal": "static-1.66888",
  "calling-lifecycle-messages": "static-1.59182",
  "commerce-products-lib": "static-1.10475",
  "conditional-properties-service-client": "static-1.3993",
  "crm-index-visualization-core": "static-1.4510",
  "crm-links": "static-1.6603",
  "crm-pipelines-api-client-types": "static-1.4328",
  "formula-editor": "static-1.14716",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4407",
  "meetings-icalendar-utils-lib": "static-1.909",
  "multi-currency-client-types": "static-1.3889",
  "object-builder-ui-client": "static-1.49609",
  "pipeline-validation-client-types": "static-1.4162",
  "smart-data-capture-core": "static-1.85",
  "smart-property-lib": "static-1.8237",
  "tiered-pricing": "static-1.1916",
  "topics-actions-lib": "static-1.437",
  "ui-addon-form-validation": "static-1.11256",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.284",
  "framework-data-schema-quick-fetch": "static-1.7070",
  "restore-request-side-panel-lib": "static-1.1620",
  "growth-data-modal": "static-1.5858",
  "growth-onboarding-confetti": "static-1.3335",
  "growth-onboarding-next-action-utils": "static-1.2641",
  "onboarding-tours-utils": "static-1.1146",
  "ui-shepherd-tracker": "static-1.7922",
  "academy-service-client": "static-1.3961",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39929",
  "SafeStorage": "static-1.4676",
  "video-embed": "static-1.36600",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24961",
  "viral-links-lib": "static-1.7349",
  "nested-table": "static-1.507",
  "timezone-utils": "static-2.5518",
  "getting-started-shared-tasks-store": "static-1.18304",
  "campaign-roi-lib": "static-1.10105",
  "campaigns-utils-lib": "static-1.3478",
  "ui-addon-calendars": "static-2.5602",
  "customer-data-views-management": "static-1.25977",
  "framework-data-table": "static-2.12501",
  "nudge-client-utils": "static-1.3115",
  "nudge-custom-ui-functions": "static-1.1455",
  "switchboard-lib": "static-1.488",
  "access-check-ui-lib": "static-1.1535",
  "app-users-service-client": "static-1.5892",
  "app-users-service-types": "static-1.5300",
  "mini-checkout-client": "static-1.27438",
  "onboarding-utils": "static-1.5638",
  "permissions-shared-i18n-strings-fe": "static-1.2119",
  "ui-coaching-tips-shared-config": "static-1.29245",
  "checkout-sdk": "static-3.24281",
  "payment-method-components": "static-1.7122",
  "touchless-buying-components": "static-1.6149",
  "upgrade-catalog-service-types": "static-1.3748",
  "edison-service-client-types": "static-1.665",
  "growth-onboarding-feedback-components": "static-1.6856",
  "audio-components": "static-1.6307",
  "FileManagerImages": "static-1.37581",
  "video-components": "static-1.14110",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92771",
  "customer-data-sidebar": "static-2.46692",
  "enrichment-lib": "static-1.264",
  "ui-addon-draggable-compat": "static-2.4539",
  "universal-record-utils-lib": "static-1.1813",
  "commerce-billing-lib": "static-1.20096",
  "commerce-shared-components-lib": "static-1.19175",
  "commerce-tools-ui-lib": "static-1.10999",
  "crm-fe-perf": "static-1.23176",
  "calling-error-reporting": "static-1.31598",
  "shared-worker-versioning": "static-1.11313",
  "calling-usage-tracker": "static-1.6810",
  "voice-sms-access-library": "static-1.1975",
  "commerce-permissions": "static-1.1050",
  "products-iframe-lib": "static-1.8541",
  "products-ui-components-shared-msw-handlers": "static-1.10955",
  "crm-index-associations-lib": "static-1.6714",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10656",
  "sales-views-client-types": "static-1.4529",
  "bark-lib": "static-1.16785",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.612",
  "policy-lib": "static-1.7072",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10719",
  "onboarding-data-sync-lib": "static-1.2467",
  "growth-onboarding-next-action-components": "static-1.2669",
  "user-context-client": "static-1.4782",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4806",
  "outpost": "static-1.4431",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22121",
  "sales-email-signature-service-client": "static-1.4117",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6557",
  "crm-view-components": "static-1.1048",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7600",
  "tasks-actions-lib": "static-1.71",
  "nudge-custom-function-registry": "static-1.2872",
  "nudge-renderer-utils": "static-1.3191",
  "whisper-core-api": "static-1.7276",
  "InboxConnectUtils": "static-4.15510",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46794",
  "hub-http-rxjs": "static-1.838",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4262",
  "company-details-components": "static-1.6476",
  "react-performance-metrics-lib": "static-1.828",
  "pricing-pages-ui-components": "static-1.15651",
  "quote-checkout-service-types": "static-1.3727",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22463",
  "customer-data-email": "static-1.18491",
  "card-payment-highlight-lib": "static-1.37927",
  "commerce-contract-lib": "static-1.13251",
  "invoices-highlight-card-lib": "static-1.55659",
  "orders-highlight-card-lib": "static-1.22146",
  "products-highlight-card-lib": "static-1.18758",
  "quotes-highlight-card-lib": "static-1.72783",
  "crm-source-interpretation-lib": "static-1.5602",
  "data-agent-utils": "static-1.326",
  "crm-object-search-query-utilities": "static-1.10153",
  "utility-belt": "static-1.2807",
  "payments-enrollment-embed-lib": "static-1.23748",
  "stripe-embedded-components": "static-1.7963",
  "customer-data-rte": "static-1.33604",
  "cv-backend-services": "static-1.1593",
  "growth-onboarding-empty-states": "static-1.6232",
  "payments-post-enroll-local-storage-lib": "static-1.5379",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38873",
  "calling-orchestration-schema": "static-1.36752",
  "react-reducer-toolkit": "static-1.16317",
  "meetings-connect-utils-lib": "static-1.7881",
  "hub-http-contrib": "static-1.3312",
  "ui-addon-sales-email": "static-1.5486",
  "access-control-lib": "static-1.10709",
  "EmailComponents": "static-1.55500",
  "EmailData": "static-1.54178",
  "redux-less": "static-2.9750",
  "company-details-service-types": "static-1.4212",
  "segments-query-core": "static-1.1696",
  "pricing-pages-api": "static-1.15516",
  "sequences-lib": "static-1.8500",
  "ui-gdpr-components": "static-1.10625",
  "products-ui-components": "static-1.40993",
  "accounting-integrations-ui-components": "static-1.7501",
  "invoices-ui-lib": "static-1.55675",
  "commerce-products-api": "static-1.2662",
  "invoices-iframe-lib": "static-1.57733",
  "quotes-modal-lib": "static-1.103461",
  "quotes-ui-lib": "static-1.81504",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28864",
  "ContentComponents": "static-2.72033",
  "ContentData": "static-1.69152",
  "marketing-contacts-lib": "static-1.10963",
  "marketing-email-service-types": "static-1.2080",
  "messaging-editing-lib": "static-1.47084",
  "messaging-usage-based-billing-components-lib": "static-1.1946",
  "automation-ui-source-apps": "static-1.19631",
  "automation-ui-types": "static-1.20549",
  "messaging-types-lib": "static-1.46821",
  "onboarding-settings-client": "static-1.4782",
  "sequences-client-types-lib": "static-1.8357",
  "commerce-tax-lib": "static-1.811",
  "price-books-api": "static-1.1687",
  "price-books-components": "static-1.1745",
  "property-description-translator": "static-1.4114",
  "ramp-editor": "static-1.850",
  "commerce-analytics-service-client": "static-1.3791",
  "totals-ui-components": "static-1.24248",
  "SalesContentIndexUI": "static-3.9596",
  "advanced-menus-core": "static-1.15542",
  "advanced-menus-lib": "static-1.12419",
  "automation-ui-ubb": "static-1.6465",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7610",
  "data-token-views": "static-1.16833",
  "forms-utils-lib": "static-1.13060",
  "payments-embed-points-lib": "static-1.13548",
  "react-tinymce": "static-1.55929",
  "simple-menus-core": "static-1.15541",
  "simple-menus-lib": "static-1.17058",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55055",
  "tinymce-data": "static-1.41140",
  "tinymce-plugins": "static-1.58169",
  "tinymce-themes": "static-1.57025",
  "ui-brand-identity-lib": "static-1.16372",
  "ui-memberships-settings-lib": "static-1.34793",
  "videoconference-integration-components": "static-1.7224",
  "marketing-contacts-client": "static-1.7784",
  "mc-hard-limits-client-types": "static-1.177",
  "automation-applications-service-types": "static-1.3651",
  "automation-platform-service-types": "static-1.2662",
  "ContentEditorUI": "static-2.77854",
  "short-messages-app-service-client": "static-1.4186",
  "web-interactives-components": "static-1.14213",
  "web-interactives-data": "static-1.14214",
  "messaging-shared-utils-lib": "static-1.1395",
  "messaging-user-info-utils-lib": "static-1.1565",
  "email-portal-health-service-types": "static-1.1252",
  "line-items-api": "static-1.1062",
  "commerce-totals-service-types": "static-1.4013",
  "FireAlarmUi": "static-1.4701",
  "sales-templates-service-types-lib": "static-1.4365",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22485",
  "automation-ui-usage-tracking": "static-1.21948",
  "data-studio-ubb": "static-1.3462",
  "interframe": "static-3.5028",
  "layout-dnd-components": "static-1.12929",
  "layout-dnd-utils": "static-1.11904",
  "NamespacedHubStyle": "static-2.9245",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27605",
  "content-management-data-lib": "static-1.5916",
  "copilot-plugins": "static-1.11777",
  "cta-picker": "static-1.37038",
  "customer-agent-discovery-components-lib": "static-1.3852",
  "editor-components": "static-1.13615",
  "editor-iframe-lib": "static-1.8763",
  "error-messaging-js": "static-1.5468",
  "FormsCommonComponents": "static-1.86510",
  "layout-data-lib": "static-1.10229",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.70",
  "redux-request-state": "static-1.10921",
  "SharedLegalStrings": "static-1.2020",
  "smart-content-core": "static-1.43129",
  "smart-content-lib": "static-1.43782",
  "social-composer-lib": "static-1.60190",
  "structured-content-lib": "static-1.25871",
  "theme-previewer-lib": "static-1.53899",
  "tinymce-copilot": "static-1.17123",
  "xray-recommendation-lib": "static-1.8233",
  "automation-ui-routing": "static-1.21906",
  "sql-reporting-client-types": "static-1.5871",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42749",
  "reporting-enablement": "static-1.23778",
  "forms-ai-lib": "static-1.4728",
  "codemirror-dlb": "static-1.59413",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6712",
  "report-customization-components": "static-1.13862",
  "data-quality-ui-library": "static-1.13743",
  "reporting-filters": "static-1.958",
  "reporting-insights-lib": "static-1.2518",
  "segments-client-types": "static-1.11452"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13179",
  "apollo-dlb": "/apollo-dlb/static-3.97",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.698",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9931",
  "foundations-components": "/foundations-components/static-1.8450",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1475",
  "foundations-theming": "/foundations-theming/static-1.4747",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8305",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10573",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11760",
  "I18n": "/I18n/static-7.1668",
  "jasmine-runner": "/jasmine-runner/static-1.6726",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.593",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13242",
  "quartz": "/quartz/static-1.7422",
  "react-dlb": "/react-dlb/static-1.88",
  "react-rhumb": "/react-rhumb/static-1.16991",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3128",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10663",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12796",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7593",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11419",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9811",
  "unified-auth": "/unified-auth/static-1.864",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1146",
  "usage-tracker": "/usage-tracker/static-1.7629",
  "usage-tracker-core": "/usage-tracker-core/static-1.7479",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8375",
  "hub-http": "/hub-http/static-1.6486",
  "integrations-lib": "/integrations-lib/static-1.16982",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20665",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.651",
  "property-management-iframe": "/property-management-iframe/static-1.14081",
  "quartz-config": "/quartz-config/static-1.1200",
  "quartz-core": "/quartz-core/static-1.6641",
  "quartz-routing": "/quartz-routing/static-1.852",
  "quick-fetch": "/quick-fetch/static-1.4111",
  "react": "/react/static-7.192",
  "rpc-client-utils": "/rpc-client-utils/static-1.4938",
  "ts-schema": "/ts-schema/static-1.4274",
  "ui-universal-auth": "/ui-universal-auth/static-1.9350",
  "UIComponents": "/UIComponents/static-3.8706",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3601",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3699",
  "quartz-webpack": "/quartz-webpack/static-1.3646",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.500",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9662",
  "codemirror": "/codemirror/static-5.99",
  "foundations-assets": "/foundations-assets/static-1.5156",
  "pulse": "/pulse/static-1.902",
  "react-codemirror": "/react-codemirror/static-1.10913",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.554",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4719",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2463",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9699",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.67",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5537",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.500",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2567",
  "ui-fonts": "/ui-fonts/static-1.1022",
  "ui-images": "/ui-images/static-2.1238",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3230",
  "foundations-theming-base": "/foundations-theming-base/static-1.3732",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.793",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3416",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4587",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8975",
  "ai-rendering-library": "/ai-rendering-library/static-1.11053",
  "chirp-fetch": "/chirp-fetch/static-1.2167",
  "connections-embed-lib": "/connections-embed-lib/static-1.1475",
  "copilot-toolkit": "/copilot-toolkit/static-1.11805",
  "feedback-loader": "/feedback-loader/static-1.29773",
  "laboratory-lib": "/laboratory-lib/static-3.7424",
  "marketplace-embed": "/marketplace-embed/static-1.22857",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10560",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20620",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14835",
  "sanitize-text": "/sanitize-text/static-1.8427",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6043",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5315",
  "wootric-nps": "/wootric-nps/static-1.7180",
  "quartz-head": "/quartz-head/static-1.1087",
  "web-vitals": "/web-vitals/static-1.12",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4929",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4423",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2665",
  "reporting-data": "/reporting-data/static-1.68730",
  "cssUtils": "/cssUtils/static-1.893",
  "flux-actions": "/flux-actions/static-1.365",
  "react-colorpicker": "/react-colorpicker/static-2.10481",
  "react-dnd-compat": "/react-dnd-compat/static-1.4890",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10642",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7619",
  "icons": "/icons/static-2.677",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19197",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4782",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5933",
  "quartz-i18n": "/quartz-i18n/static-1.1097",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.411",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1216",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.982",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.77",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.422",
  "slack-ui-library": "/slack-ui-library/static-1.10671",
  "fsm": "/fsm/static-1.4021",
  "customer-data-objects": "/customer-data-objects/static-1.7963",
  "property-translator": "/property-translator/static-1.5671",
  "hs-locale-management": "/hs-locale-management/static-1.274",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8196",
  "hs-promise-utils": "/hs-promise-utils/static-1.5870",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5152",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14397",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5881",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8052",
  "sanitize": "/sanitize/static-1.4747",
  "superstore": "/superstore/static-1.5030",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10540",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8288",
  "hub-http-janus": "/hub-http-janus/static-1.874",
  "hubspotter-http": "/hubspotter-http/static-1.4845",
  "immutable-less": "/immutable-less/static-1.4923",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18072",
  "nav-meta": "/nav-meta/static-1.30408",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18347",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.965",
  "ai-studio-lib": "/ai-studio-lib/static-1.12411",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18923",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.448",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9350",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8298",
  "ui-product-approvals": "/ui-product-approvals/static-1.29070",
  "ui-tool-access": "/ui-tool-access/static-1.10426",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4037",
  "property-management-common": "/property-management-common/static-1.6369",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.43",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.574",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.418",
  "quartz-auth": "/quartz-auth/static-1.1097",
  "quartz-test": "/quartz-test/static-1.1097",
  "quartz-tracking": "/quartz-tracking/static-1.801",
  "trellis-components": "/trellis-components/static-1.2586",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.348",
  "HubStyle": "/HubStyle/static-2.12067",
  "bender-build-tools": "/bender-build-tools/static-1.3425",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22843",
  "ContentUtils": "/ContentUtils/static-1.69077",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13304",
  "sassPrefix": "/sassPrefix/static-1.166",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.405",
  "batch-promise": "/batch-promise/static-1.1817",
  "event-emitter": "/event-emitter/static-1.1226",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5737",
  "magpie-types": "/magpie-types/static-1.5197",
  "stylex-utils": "/stylex-utils/static-1.137",
  "trellis-theming": "/trellis-theming/static-1.1243",
  "avatar-components": "/avatar-components/static-1.2766",
  "breeze-engine-core": "/breeze-engine-core/static-1.929",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.667",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40836",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13452",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15459",
  "ExportDialog": "/ExportDialog/static-6.10652",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41973",
  "reporting-snowflake": "/reporting-snowflake/static-1.57347",
  "reporting-ui-components": "/reporting-ui-components/static-2.66000",
  "reporting-visualizations": "/reporting-visualizations/static-1.60805",
  "trial-components-library": "/trial-components-library/static-1.14067",
  "ui-addon-teams": "/ui-addon-teams/static-1.21880",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.482",
  "navigation-components": "/navigation-components/static-1.18771",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1651",
  "simple-logging-lib": "/simple-logging-lib/static-1.3324",
  "fail-safe": "/fail-safe/static-1.226",
  "app-governance-lib": "/app-governance-lib/static-1.2345",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10777",
  "purchase-motions-components": "/purchase-motions-components/static-1.6316",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10154",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6046",
  "usage-tracker-public": "/usage-tracker-public/static-1.7440",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3974",
  "reference-resolvers": "/reference-resolvers/static-1.8455",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4191",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.611",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3281",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3488",
  "atom": "/atom/static-1.5358",
  "merchandise-lib": "/merchandise-lib/static-1.276",
  "salesImages": "/salesImages/static-1.537",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5031",
  "content-assistance-lib": "/content-assistance-lib/static-1.8165",
  "content-media-capture": "/content-media-capture/static-1.5380",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10102",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24430",
  "growth-payments-core": "/growth-payments-core/static-1.26129",
  "knowledge-content-types": "/knowledge-content-types/static-1.8638",
  "PatternValidationJS": "/PatternValidationJS/static-1.3168",
  "payment-link-components": "/payment-link-components/static-1.24120",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20271",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10159",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9360",
  "video-components-external": "/video-components-external/static-1.12108",
  "video-data-lib": "/video-data-lib/static-1.35766",
  "navigation-messaging": "/navigation-messaging/static-1.8098",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58665",
  "crm-component-utils": "/crm-component-utils/static-1.39785",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6163",
  "customer-data-properties": "/customer-data-properties/static-1.52504",
  "external-options-client-types": "/external-options-client-types/static-1.4320",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7165",
  "property-value-citations": "/property-value-citations/static-1.3118",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8376",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10571",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5088",
  "content-icons-ui": "/content-icons-ui/static-1.2336",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.993",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.256",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.868",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7519",
  "crm-message-bus": "/crm-message-bus/static-1.43703",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23271",
  "events-data-lib": "/events-data-lib/static-1.516",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5000",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4202",
  "hs-resources": "/hs-resources/static-1.466",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1273",
  "onboarding-scopes": "/onboarding-scopes/static-1.6726",
  "onboarding-tours": "/onboarding-tours/static-1.17080",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14418",
  "academy-common-lib": "/academy-common-lib/static-1.14919",
  "dashboard-lib": "/dashboard-lib/static-1.82736",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19186",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18915",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8977",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11371",
  "user-context": "/user-context/static-1.5392",
  "reporting-plugins": "/reporting-plugins/static-1.10711",
  "reporting-reports": "/reporting-reports/static-1.68407",
  "hubs-service-types": "/hubs-service-types/static-1.1531",
  "purchase-motions-api": "/purchase-motions-api/static-1.6319",
  "signup-constants": "/signup-constants/static-1.19568",
  "nest": "/nest/static-1.509",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.629",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.177",
  "framework-listing-lib": "/framework-listing-lib/static-2.29441",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31375",
  "apps-service-types": "/apps-service-types/static-1.4013",
  "oauth-service-types": "/oauth-service-types/static-1.4510",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8335",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5294",
  "one-click-checkout": "/one-click-checkout/static-1.343",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7874",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15224",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3767",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10048",
  "redux-thunk": "/redux-thunk/static-2.77",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29260",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13184",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4698",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.669",
  "ui-addon-opt": "/ui-addon-opt/static-4.8637",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6577",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5353",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3803",
  "data-token-picker": "/data-token-picker/static-1.16852",
  "FileManagerLib": "/FileManagerLib/static-1.40070",
  "content-media-compositions": "/content-media-compositions/static-2.17191",
  "media-bridge-lib": "/media-bridge-lib/static-1.19372",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22834",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3462",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7142",
  "card-properties-lib": "/card-properties-lib/static-1.44959",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37727",
  "crm-actions": "/crm-actions/static-1.6625",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44493",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9900",
  "customer-data-tracking": "/customer-data-tracking/static-1.7154",
  "calling-global-api": "/calling-global-api/static-1.65506",
  "calling-internal-common": "/calling-internal-common/static-1.31591",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66888",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59182",
  "commerce-products-lib": "/commerce-products-lib/static-1.10475",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3993",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4510",
  "crm-links": "/crm-links/static-1.6603",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4328",
  "formula-editor": "/formula-editor/static-1.14716",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4407",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.909",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3889",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49609",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4162",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.85",
  "smart-property-lib": "/smart-property-lib/static-1.8237",
  "tiered-pricing": "/tiered-pricing/static-1.1916",
  "topics-actions-lib": "/topics-actions-lib/static-1.437",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11256",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.284",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7070",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1620",
  "growth-data-modal": "/growth-data-modal/static-1.5858",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3335",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2641",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1146",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7922",
  "academy-service-client": "/academy-service-client/static-1.3961",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39929",
  "SafeStorage": "/SafeStorage/static-1.4676",
  "video-embed": "/video-embed/static-1.36600",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24961",
  "viral-links-lib": "/viral-links-lib/static-1.7349",
  "nested-table": "/nested-table/static-1.507",
  "timezone-utils": "/timezone-utils/static-2.5518",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18304",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10105",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3478",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5602",
  "customer-data-views-management": "/customer-data-views-management/static-1.25977",
  "framework-data-table": "/framework-data-table/static-2.12501",
  "nudge-client-utils": "/nudge-client-utils/static-1.3115",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1455",
  "switchboard-lib": "/switchboard-lib/static-1.488",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1535",
  "app-users-service-client": "/app-users-service-client/static-1.5892",
  "app-users-service-types": "/app-users-service-types/static-1.5300",
  "mini-checkout-client": "/mini-checkout-client/static-1.27438",
  "onboarding-utils": "/onboarding-utils/static-1.5638",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2119",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29245",
  "checkout-sdk": "/checkout-sdk/static-3.24281",
  "payment-method-components": "/payment-method-components/static-1.7122",
  "touchless-buying-components": "/touchless-buying-components/static-1.6149",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3748",
  "edison-service-client-types": "/edison-service-client-types/static-1.665",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6856",
  "audio-components": "/audio-components/static-1.6307",
  "FileManagerImages": "/FileManagerImages/static-1.37581",
  "video-components": "/video-components/static-1.14110",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92771",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46692",
  "enrichment-lib": "/enrichment-lib/static-1.264",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4539",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1813",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20096",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19175",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10999",
  "crm-fe-perf": "/crm-fe-perf/static-1.23176",
  "calling-error-reporting": "/calling-error-reporting/static-1.31598",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11313",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6810",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1975",
  "commerce-permissions": "/commerce-permissions/static-1.1050",
  "products-iframe-lib": "/products-iframe-lib/static-1.8541",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10955",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6714",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10656",
  "sales-views-client-types": "/sales-views-client-types/static-1.4529",
  "bark-lib": "/bark-lib/static-1.16785",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.612",
  "policy-lib": "/policy-lib/static-1.7072",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10719",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2467",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2669",
  "user-context-client": "/user-context-client/static-1.4782",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4806",
  "outpost": "/outpost/static-1.4431",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22121",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4117",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6557",
  "crm-view-components": "/crm-view-components/static-1.1048",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7600",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.71",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2872",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3191",
  "whisper-core-api": "/whisper-core-api/static-1.7276",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15510",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46794",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.838",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4262",
  "company-details-components": "/company-details-components/static-1.6476",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.828",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15651",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3727",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22463",
  "customer-data-email": "/customer-data-email/static-1.18491",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37927",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13251",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55659",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22146",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18758",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72783",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5602",
  "data-agent-utils": "/data-agent-utils/static-1.326",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10153",
  "utility-belt": "/utility-belt/static-1.2807",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23748",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7963",
  "customer-data-rte": "/customer-data-rte/static-1.33604",
  "cv-backend-services": "/cv-backend-services/static-1.1593",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6232",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5379",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38873",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36752",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16317",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7881",
  "hub-http-contrib": "/hub-http-contrib/static-1.3312",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5486",
  "access-control-lib": "/access-control-lib/static-1.10709",
  "EmailComponents": "/EmailComponents/static-1.55500",
  "EmailData": "/EmailData/static-1.54178",
  "redux-less": "/redux-less/static-2.9750",
  "company-details-service-types": "/company-details-service-types/static-1.4212",
  "segments-query-core": "/segments-query-core/static-1.1696",
  "pricing-pages-api": "/pricing-pages-api/static-1.15516",
  "sequences-lib": "/sequences-lib/static-1.8500",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10625",
  "products-ui-components": "/products-ui-components/static-1.40993",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7501",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55675",
  "commerce-products-api": "/commerce-products-api/static-1.2662",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57733",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103461",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81504",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28864",
  "ContentComponents": "/ContentComponents/static-2.72033",
  "ContentData": "/ContentData/static-1.69152",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10963",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2080",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47084",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1946",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19631",
  "automation-ui-types": "/automation-ui-types/static-1.20549",
  "messaging-types-lib": "/messaging-types-lib/static-1.46821",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4782",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8357",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.811",
  "price-books-api": "/price-books-api/static-1.1687",
  "price-books-components": "/price-books-components/static-1.1745",
  "property-description-translator": "/property-description-translator/static-1.4114",
  "ramp-editor": "/ramp-editor/static-1.850",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3791",
  "totals-ui-components": "/totals-ui-components/static-1.24248",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9596",
  "advanced-menus-core": "/advanced-menus-core/static-1.15542",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12419",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6465",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7610",
  "data-token-views": "/data-token-views/static-1.16833",
  "forms-utils-lib": "/forms-utils-lib/static-1.13060",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13548",
  "react-tinymce": "/react-tinymce/static-1.55929",
  "simple-menus-core": "/simple-menus-core/static-1.15541",
  "simple-menus-lib": "/simple-menus-lib/static-1.17058",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55055",
  "tinymce-data": "/tinymce-data/static-1.41140",
  "tinymce-plugins": "/tinymce-plugins/static-1.58169",
  "tinymce-themes": "/tinymce-themes/static-1.57025",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16372",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34793",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7224",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7784",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.177",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3651",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2662",
  "ContentEditorUI": "/ContentEditorUI/static-2.77854",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4186",
  "web-interactives-components": "/web-interactives-components/static-1.14213",
  "web-interactives-data": "/web-interactives-data/static-1.14214",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1395",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1565",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1252",
  "line-items-api": "/line-items-api/static-1.1062",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4013",
  "FireAlarmUi": "/FireAlarmUi/static-1.4701",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4365",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22485",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21948",
  "data-studio-ubb": "/data-studio-ubb/static-1.3462",
  "interframe": "/interframe/static-3.5028",
  "layout-dnd-components": "/layout-dnd-components/static-1.12929",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11904",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9245",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27605",
  "content-management-data-lib": "/content-management-data-lib/static-1.5916",
  "copilot-plugins": "/copilot-plugins/static-1.11777",
  "cta-picker": "/cta-picker/static-1.37038",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3852",
  "editor-components": "/editor-components/static-1.13615",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8763",
  "error-messaging-js": "/error-messaging-js/static-1.5468",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86510",
  "layout-data-lib": "/layout-data-lib/static-1.10229",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.70",
  "redux-request-state": "/redux-request-state/static-1.10921",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2020",
  "smart-content-core": "/smart-content-core/static-1.43129",
  "smart-content-lib": "/smart-content-lib/static-1.43782",
  "social-composer-lib": "/social-composer-lib/static-1.60190",
  "structured-content-lib": "/structured-content-lib/static-1.25871",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53899",
  "tinymce-copilot": "/tinymce-copilot/static-1.17123",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8233",
  "automation-ui-routing": "/automation-ui-routing/static-1.21906",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5871",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42749",
  "reporting-enablement": "/reporting-enablement/static-1.23778",
  "forms-ai-lib": "/forms-ai-lib/static-1.4728",
  "codemirror-dlb": "/codemirror-dlb/static-1.59413",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6712",
  "report-customization-components": "/report-customization-components/static-1.13862",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13743",
  "reporting-filters": "/reporting-filters/static-1.958",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2518",
  "segments-client-types": "/segments-client-types/static-1.11452"
}
};
